"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _divider = _interopRequireDefault(require("../Divider/divider"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var HeaderActionsDivider = function HeaderActionsDivider() {
  return _react.default.createElement(_divider.default, {
    vertical: true
  });
};

HeaderActionsDivider.displayName = 'Header.Actions.Divider';
var _default = HeaderActionsDivider;
exports.default = _default;
HeaderActionsDivider.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "Header.Actions.Divider"
};